import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { INVOICE_ACTIONS, PRIMARY_ACTIONS_MAPPING } from '../../../consts/consts';
import {
  isInvoiceStatusCancelled,
  isInvoiceStatusPaid,
  isInvoiceStatusSent,
  isInvoiceStatusUnsent,
} from '../../../utils';
import { HUB_MODALS } from '../../InvoiceHubModals';
import { useStore } from '../../../../../../store';

export const PrimaryInvoiceActions = ({ status }: { status: string }) => {
  const setActiveModal = useStore((state) => state.setActiveModal);
  const { t } = useTranslation();
  const buttonsList = useMemo(() => {
    if (isInvoiceStatusSent(status)) return PRIMARY_ACTIONS_MAPPING.SENT;
    if (isInvoiceStatusUnsent(status)) return PRIMARY_ACTIONS_MAPPING.UNSENT;
    if (isInvoiceStatusPaid(status)) return PRIMARY_ACTIONS_MAPPING.PAID;
    if (isInvoiceStatusCancelled(status)) return PRIMARY_ACTIONS_MAPPING.CANCELED;
    return null;
  }, [status]);
  const handleOnClick = (name: string) => {
    if (name === INVOICE_ACTIONS.MARK_AS_PAID) setActiveModal(HUB_MODALS.MARK_AS_PAID);
    if (name === INVOICE_ACTIONS.MARK_AS_UNPAID) setActiveModal(HUB_MODALS.MARK_AS_UNPAID);
    if (name === INVOICE_ACTIONS.SHARE_INVOICE) setActiveModal(HUB_MODALS.SOCIAL_SHARE);
  };
  if (!buttonsList) return null;
  return (
    <div className='flex'>
      {buttonsList.map((button, index) => {
        const isPrimary = index === 0;
        return (
          <div key={button.key}>
            <LiliButton
              id={`invoice_page_main_action_${button.key}`}
              title={t(button.title as any)}
              className={`h-[40px] ${button?.width ? button?.width : 'w-[164px]'} ${index === 0 ? 'mr-[12px]' : ''}`}
              icon={button.SVGIcon ? <button.SVGIcon /> : null}
              onClick={() => handleOnClick(button.name)}
              type={isPrimary ? LiliButtonType.PRIMARY : LiliButtonType.SECONDARY}
            />
          </div>
        );
      })}
    </div>
  );
};
